/* ============================================================
   Özel Paketler — landing sayfası (Faz 5)
   ------------------------------------------------------------
   - Volume kartı (.fos-pc--vol) tıklama → global builder modalı
     (package-builder.js, theme.liquid'de). Manşet kademe için
     data-collection / data-qty / data-total taşır; ürünleri builder
     koleksiyon handle'ıyla kendisi yükler.
   - Combo kartı (slot-bazlı, [data-fos-pc-combo]) tıklama → aynı builder
     ama heterojen slotlarla (her slot kendi koleksiyonundan), hepsi BOŞ
     (landing'de "bakılan ürün" yok — kullanıcı tüm parçaları seçer).
   - link_card (Kulüp vb.) düz link (<a>) — JS yok.
   ============================================================ */
(function () {
  'use strict';

  if (window.fosPackageLandingInitialized) {
    return;
  }
  window.fosPackageLandingInitialized = true;

  document.addEventListener('click', function (e) {
    var card = e.target.closest('.fos-pc--vol');
    if (!card) {
      return;
    }
    e.preventDefault();
    if (!window.fosBuilder || typeof window.fosBuilder.open !== 'function') {
      return;
    }
    window.fosBuilder.open({
      qty: parseInt(card.getAttribute('data-qty'), 10),
      totalCents: parseInt(card.getAttribute('data-total'), 10),
      freeQuantity: parseInt(card.getAttribute('data-free'), 10) || 0,
      packageHandle: card.getAttribute('data-package-handle'),
      collection: card.getAttribute('data-collection'),
      excludeTags: (card.getAttribute('data-exclude') || '')
        .split(',').map(function (s) { return s.trim(); }).filter(Boolean),
      resumeFromCart: true,
      locked: []
    });
  });

  /* ------------------------------------------------------------
     Derin link: /pages/ozel-paketler?paket=<handle>
     Menüden gelen kullanıcı sayfada kartı aramak zorunda kalmasın,
     ilgili paketin builder'ı doğrudan açılsın. Kart bulunamazsa
     (paket kaldırılmış olabilir) hiçbir şey yapılmaz — sayfa normal
     landing olarak kalır.
     ------------------------------------------------------------ */
  /* Sayfadaki kartlar merchandising kararı: bazı paketler builder butonu
     yerine koleksiyon linki olarak duruyor, bazılarının kartı hiç yok.
     Derin link kartlara bağlı kalmasın diye paketin builder verisi
     go-cart.liquid'in bastığı veri adasından okunur (her sayfada var). */
  function openFromDataIsland(handle) {
    var el = document.getElementById('fos-cart-packages-data');
    if (!el) {
      return false;
    }
    var list;
    try {
      list = JSON.parse(el.textContent);
    } catch (err) {
      return false;
    }

    var pkg = null;
    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === handle) {
        pkg = list[i];
        break;
      }
    }
    if (!pkg) {
      return false;
    }

    if (pkg.kind === 'combo' && pkg.slotMode && pkg.slots && pkg.slots.length) {
      window.fosBuilder.open({
        totalCents: pkg.totalCents,
        packageHandle: handle,
        excludeTags: pkg.excludeTags || [],
        resumeFromCart: true,
        slots: pkg.slots.map(function (s) { return { collection: s.collectionHandle }; })
      });
      return true;
    }

    if ((pkg.kind === 'volume' || pkg.kind === 'bxgy') && pkg.tiers && pkg.tiers.length) {
      // Manşet kademe = en yüksek adet; kartlardaki mantıkla aynı.
      var top = pkg.tiers[0];
      for (var t = 1; t < pkg.tiers.length; t++) {
        if (pkg.tiers[t].qty > top.qty) {
          top = pkg.tiers[t];
        }
      }
      window.fosBuilder.open({
        qty: top.qty,
        totalCents: top.total,
        freeQuantity: top.freeQuantity || 0,
        packageHandle: handle,
        collection: pkg.collectionHandle,
        excludeTags: pkg.excludeTags || [],
        resumeFromCart: true,
        locked: []
      });
      return true;
    }

    return false;
  }

  function openDeepLinkedPackage() {
    var handle;
    try {
      handle = new URLSearchParams(window.location.search).get('paket');
    } catch (err) {
      return;
    }
    if (!handle) {
      return;
    }

    var card =
      document.querySelector('[data-fos-pc-combo="' + handle + '"]') ||
      document.querySelector('.fos-pc--vol[data-package-handle="' + handle + '"]');

    // Modal kapanınca kullanıcı doğru kartın önünde kalsın.
    var anchor = card || document.getElementById('paket-' + handle);
    if (anchor) {
      anchor.scrollIntoView({ block: 'center', behavior: 'auto' });
    }

    // fosBuilder theme.liquid'den defer ile yükleniyor; hazır olana kadar
    // kısa süre bekle, sonsuza kadar değil.
    var tries = 0;
    (function waitForBuilder() {
      if (window.fosBuilder && typeof window.fosBuilder.open === 'function') {
        if (card) {
          card.click();
        } else {
          openFromDataIsland(handle);
        }
        return;
      }
      if (tries++ > 40) {
        return;
      }
      setTimeout(waitForBuilder, 50);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openDeepLinkedPackage);
  } else {
    openDeepLinkedPackage();
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-fos-pc-combo]');
    if (!card) {
      return;
    }
    e.preventDefault();
    if (!window.fosBuilder || typeof window.fosBuilder.open !== 'function') {
      return;
    }
    var handle = card.getAttribute('data-fos-pc-combo');
    var dataEl = document.querySelector('script[data-fos-pc-combo-data="' + handle + '"]');
    if (!dataEl) {
      return;
    }
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }
    window.fosBuilder.open({
      totalCents: data.totalCents,
      packageHandle: handle,
      excludeTags: data.excludeTags || [],
      resumeFromCart: true,
      slots: data.slots.map(function (s) { return { collection: s.collectionHandle }; })
    });
  });
})();
